import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const combineClassSkillsTraining = {
    combineClass: {
        list: config => createAPI('/combineClassSkillsTraining/list', 'post', config),
        siteTypeOption: config => createAPI('/combineClassSkillsTraining/siteTypeOption', 'post', config),
        majorOption: config => createAPI('/combineClassSkillsTraining/majorOption', 'post', config),
        classOption: config => createAPI('/combineClassSkillsTraining/classOption', 'post', config),
        courseOption: config => createAPI('/combineClassSkillsTraining/courseOption', 'post', config),
        querySkjh2List: config => createAPI('/combineClassSkillsTraining/querySkjh2List', 'post', config),
        querySkjh3List: config => createAPI('/combineClassSkillsTraining/querySkjh3List', 'post', config),
        changeSkjh: config => createAPI('/combineClassSkillsTraining/changeSkjh', 'post', config),
        editRoom: config => createAPI('/combineClassSkillsTraining/editRoom', 'post', config),
        checkpaike: config => createAPI('/combineClassSkillsTraining/checkpaike', 'post', config),
        deleteHB: config => createAPI('/combineClassSkillsTraining/deleteHB', 'post', config),
    },

};
export default combineClassSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/combineClassSkillsTraining.js